






















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { storePasien } from "@/store/modules/pasien";
import { storeCatatanEdukasi } from "@/store/modules/catatanedukasi";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import DataCatatanEdukasi from "@/services/DataCatatanEdukasi";
import DataUtility from "@/services/DataUtility";
import { storePerawat } from "@/store/modules/perawat";
import http from "@/axios/http-common";
import moment from "moment";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import TtdPadDialog from "@/components/common/TtdPadDialog.vue";
import { materiEdukasiFor } from "@/constants/materiEdukasi";

@Component({
  components: { UnitRuangPicker, VCDateTimePicker, TtdPadDialog },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardCatatanEdukasi extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  created() {
    if (this.register) {
      storeCatatanEdukasi.actCatatanEdukasi(this.register);
    }
    this.fetchPekerjaan();
  }

  @Watch("register")
  registerBerubah(val) {
    if (val) storeCatatanEdukasi.actCatatanEdukasi(val);
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get bisaSimpan(): boolean {
    return !this.readOnly;
  }

  saving = false;
  savingProfesi: number | null = null;
  panel = 0;
  itemPenerima = [
    { nama: "Pasien", id: "P" },
    { nama: "Orangtua", id: "O" },
    { nama: "Keluarga", id: "K" },
    { nama: "Lainnya", id: "L" }
  ];
  // Sub-opsi hubungan saat penerima edukasi = Keluarga (K)
  itemHubunganKeluarga = [
    "Suami",
    "Istri",
    "Anak",
    "Kakak",
    "Adik",
    "Kakek",
    "Nenek"
  ];
  itemMetode = [
    { metode: "Diskusi (D)", id: "D" },
    { metode: "Demonstrasi (demo)", id: "demo" },
    { metode: "Ceramah (C)", id: "C" },
    { metode: "Simulasi (S)", id: "S" },
    { metode: "Observasi (O)", id: "O" },
    { metode: "Praktek Langsung (PL)", id: "PL" },
    { metode: "Lisan", id: "1" },
    { metode: "Tulisan/ Leaflet", id: "2" },
    { metode: "Demonstras", id: "3" }
  ];
  itemEvaluasi = [
    { evaluasi: "Tidak Mengerti", id: "1" },
    { evaluasi: "Mengerti /paham", id: "2" },
    { evaluasi: "Bisa menjelaskan", id: "3" }
  ];
  itemTinggal = [
    { nama: "Anak", id: "1" },
    { nama: "Orang Tua", id: "2" },
    { nama: "Sendiri", id: "3" },
    { nama: "Suami/Istri", id: "4" },
    { nama: "Orang Lain", id: "0" }
  ];
  itemBahasa = [
    { nama: "Indonesia, aktif/pasif", id: "1" },
    { nama: "Daerah", id: "D" },
    { nama: "Inggris, aktif/pasif", id: "2" },
    { nama: "Arab", id: "3" },
    { nama: "Lainnya", id: "0" }
  ];
  itemAgama = [
    { nama: "Islam", id: "1" },
    { nama: "Katholik", id: "2" },
    { nama: "Kristen", id: "3" },
    { nama: "Hindu", id: "4" },
    { nama: "Budha", id: "5" },
    { nama: "Lainnya", id: "0" }
  ];
  itemPendidikan = [
    { nama: "TK", id: "TK" },
    { nama: "SD", id: "1" },
    { nama: "SLTP", id: "2" },
    { nama: "SLTA", id: "3" },
    { nama: "Akademi / D3", id: "4" },
    { nama: "Sarjana / S1", id: "5" },
    { nama: "Lainnya", id: "0" }
  ];
  hambatanEdukasi = [
    {
      id: "1",
      nama: "Gangguan Pendengaran"
    },
    {
      id: "2",
      nama: "Gangguan Bicara"
    },
    {
      id: "3",
      nama: "Fisik Lemah"
    },
    {
      id: "4",
      nama: "Secara fisiologis tidak mampu belajar"
    },
    {
      id: "5",
      nama: "Gangguan Emosi"
    },
    {
      id: "6",
      nama: "Motivasi Kurang/Buruk"
    },
    {
      id: "7",
      nama: "Alkoholik"
    },
    {
      id: "8",
      nama: "Gangguan Penglihatan"
    },
    {
      id: "9",
      nama: "Memori Hilang"
    },
    {
      id: "10",
      nama: "Perokok Aktif/Pasif "
    },
    {
      id: "11",
      nama: "Lainnya"
    }
  ];

  hambatanKomunikasi = [
    { id: "aphasia_motorik", nama: "Aphasia motorik" },
    { id: "aphasia_sensorik", nama: "Aphasia sensorik" },
    { id: "tuli", nama: "Tuli" },
    { id: "tidak_ada", nama: "Tidak ada" },
    { id: "lain", nama: "Lainnya" }
  ];

  hambatanEmosi = [
    { id: "tenang", nama: "Tenang" },
    { id: "cemas", nama: "Cemas" },
    { id: "gelisah", nama: "Gelisah" },
    { id: "sedih", nama: "Sedih" },
    { id: "menangis", nama: "Menangis" },
    { id: "mudah_tersinggung", nama: "Mudah tersinggung" },
    { id: "marah_tegang", nama: "Marah / tegang" },
    { id: "takut_therapy", nama: "Takut therapy / lingkungan RS" },
    { id: "tidak_ada_partisipasi", nama: "Tidak ada partisipasi" }
  ];

  pendidikanKesehatan = [
    { id: "proses_penyakit", nama: "Proses penyakit" },
    { id: "pengobatan_tindakan", nama: "Pengobatan / tindakan" },
    { id: "therapi_obat", nama: "Therapi / obat" },
    { id: "nutrisi", nama: "Nutrisi" },
    { id: "lain", nama: "Lain-lainnya" }
  ];

  bahasaSehariHari = [
    { id: "indonesia", nama: "Indonesia, aktif / pasif" },
    { id: "daerah", nama: "Daerah" },
    { id: "inggris", nama: "Inggris, aktif / pasif" },
    { id: "lain", nama: "Lain-lain" }
  ];

  isHambatanLain = false;
  isHambatanKomunikasiLain = false;
  isPendidikanKesehatanLain = false;
  isBahasaDaerah = false;
  isBahasaLain = false;

  hasPenerimaLain(row): boolean {
    return (
      !!row &&
      Array.isArray(row.penerima) &&
      row.penerima.some(x => x && x.id === "L")
    );
  }

  get isPenerimaLain(): boolean {
    return this.hasPenerimaLain(this.catatan["kebutuhan_edukasi"]);
  }

  hasPenerimaKeluarga(row): boolean {
    return (
      !!row &&
      Array.isArray(row.penerima) &&
      row.penerima.some(x => x && x.id === "K")
    );
  }

  get isPenerimaKeluarga(): boolean {
    return this.hasPenerimaKeluarga(this.catatan["kebutuhan_edukasi"]);
  }

  pend = {};
  religion = {};
  // Master pekerjaan (c_pkj) diambil saat komponen dibuat.
  itemPekerjaan: Array<{ id: string; nama: string }> = [];
  // Penanda petugas sudah menyentuh isian pekerjaan — mencegah prefill identitas
  // pasien menimpa (atau mengisi ulang) nilai yang sengaja dikosongkan.
  pekerjaanDiisi = false;

  profesiLabel(profesi) {
    const map = {
      Dokter: "Dokter Spesialis / Umum / Gigi",
      Nutrisionist: "Nutrisi",
      Perawat: "Perawat / Bidan",
      "Rehabilitasi Medik": "Rehabilitasi Medis",
      MPP: "MPP (Manajer Pelayanan Pasien)"
    };
    return map[profesi] || profesi;
  }

  @Watch("catatan.kebutuhan_edukasi.hambatan_komunikasi")
  changedHambatanKomunikasi(v, old) {
    if (!v || !Array.isArray(v)) {
      this.isHambatanKomunikasiLain = false;
      return;
    }
    const punyaTidakAda = arr =>
      (arr || []).some(item => item && item.id === "tidak_ada");
    if (v.length > 1 && punyaTidakAda(v)) {
      // "Tidak ada" eksklusif: baru dicentang -> buang pilihan lain,
      // sudah tercentang lalu pilih yang lain -> buang "Tidak ada".
      this.catatan["kebutuhan_edukasi"].hambatan_komunikasi = punyaTidakAda(old)
        ? v.filter(item => item.id !== "tidak_ada")
        : v.filter(item => item.id === "tidak_ada");
      return;
    }
    this.isHambatanKomunikasiLain = v.some(item => item && item.id === "lain");
  }

  @Watch("catatan.kebutuhan_edukasi.pendidikan_kesehatan")
  changedPendidikanKesehatan(v) {
    if (!v || !Array.isArray(v)) {
      this.isPendidikanKesehatanLain = false;
      return;
    }
    this.isPendidikanKesehatanLain = v.some(
      item => item && item.id === "lain"
    );
  }

  @Watch("catatan.kebutuhan_edukasi.bahasa_sehari")
  changedBahasaSehari(v) {
    if (!v || !Array.isArray(v)) {
      this.isBahasaDaerah = false;
      this.isBahasaLain = false;
      return;
    }
    this.isBahasaDaerah = v.some(item => item && item.id === "daerah");
    this.isBahasaLain = v.some(item => item && item.id === "lain");
  }
  get pendidikan() {
    if (this.catatan["id"] == undefined) {
      this.pend = {};
      this.catatan["kebutuhan_edukasi"].pendidikan_lain = "";
      this.catatan["kebutuhan_edukasi"].pendidikan = {};
      if (this.statePasien.pendidikan == "Tamat SD") {
        this.pend = { nama: "SD", id: "1" };
      } else if (this.statePasien.pendidikan == "Tamat SMP") {
        this.pend = { nama: "SLTP", id: "2" };
      } else if (this.statePasien.pendidikan == "Tamat SMA") {
        this.pend = { nama: "SLTA", id: "3" };
        // } else if (this.statePasien.pendidikan == "Tamat Ak/Univ") {
        //   this.pend = { nama: "S1", id: "5" };
        // } else if (this.statePasien.pendidikan == "Tamat Ak/Univ") {
        //   this.pend = {};
      } else {
        this.pend = { nama: "Lainnya", id: "0" };
        this.catatan[
          "kebutuhan_edukasi"
        ].pendidikan_lain = this.statePasien.pendidikan;
      }
    } else {
      this.pend = this.catatan["kebutuhan_edukasi"].pendidikan;
    }
    this.catatan["kebutuhan_edukasi"].pendidikan = this.pend;
    return this.pend;
  }

  set pendidikan(val) {
    this.catatan["kebutuhan_edukasi"].pendidikan = val;
  }

  // Pekerjaan memakai master c_pkj (GET combo/pekerjaan) dengan pola sama seperti
  // Pendidikan/Agama: pilihan "LAIN-LAIN" membuka isian bebas `pekerjaan_lain`.
  // Prefill dari identitas pasien dilakukan di watcher (bukan getter) agar
  // petugas tetap bisa mengganti/mengosongkan pilihan.
  get pekerjaan() {
    const ke = this.catatan["kebutuhan_edukasi"];
    return (ke && ke.pekerjaan) || null;
  }

  set pekerjaan(val) {
    this.pekerjaanDiisi = true;
    this.$set(this.catatan["kebutuhan_edukasi"], "pekerjaan", val || "");
    if (!this.isPekerjaanLainId(val ? val.id : null)) {
      this.$set(this.catatan["kebutuhan_edukasi"], "pekerjaan_lain", "");
    }
  }

  get isPekerjaanLain() {
    const ke = this.catatan["kebutuhan_edukasi"];
    return !!(ke && ke.pekerjaan && this.isPekerjaanLainId(ke.pekerjaan.id));
  }

  // Kode master: "09" = LAIN-LAIN, "-" = TIDAK TAHU. Nama ikut dicek agar tetap
  // jalan bila kode master berubah.
  isPekerjaanLainId(id, nama?) {
    if (id === undefined || id === null || id === "") return false;
    if (String(id) === "09") return true;
    const label =
      nama !== undefined
        ? nama
        : (this.itemPekerjaan.find(o => String(o.id) === String(id)) || {})
            .nama;
    return String(label || "")
      .toLowerCase()
      .startsWith("lain");
  }

  async fetchPekerjaan() {
    const dt = await DataUtility.getListPekerjaan();
    const list = Array.isArray(dt) ? dt.slice() : [];
    // Master menulis "LAIN-LAIN"; di form ditampilkan "Lainnya" dan selalu
    // ditaruh paling bawah (kode master tidak diubah — dipakai bersama simpelrm).
    list.forEach(o => {
      if (this.isPekerjaanLainId(o.id, o.nama)) o.nama = "Lainnya";
    });
    list.sort((a, b) => {
      const aLain = this.isPekerjaanLainId(a.id, a.nama) ? 1 : 0;
      const bLain = this.isPekerjaanLainId(b.id, b.nama) ? 1 : 0;
      if (aLain !== bLain) return aLain - bLain;
      return String(a.nama).localeCompare(String(b.nama));
    });
    this.itemPekerjaan = list;
    this.prefillPekerjaan();
  }

  @Watch("catatan")
  catatanChangedForPekerjaan() {
    this.pekerjaanDiisi = false;
    this.prefillPekerjaan();
  }

  @Watch("statePasien")
  pasienChangedForPekerjaan() {
    this.prefillPekerjaan();
  }

  prefillPekerjaan() {
    const ke = this.catatan && this.catatan["kebutuhan_edukasi"];
    if (!ke) return;
    // Catatan lama bisa belum punya properti ini — didaftarkan agar reaktif.
    if (ke.pekerjaan === undefined) this.$set(ke, "pekerjaan", "");
    if (ke.pekerjaan_lain === undefined) this.$set(ke, "pekerjaan_lain", "");

    if (this.catatan["id"] != undefined || this.pekerjaanDiisi) return;
    if (ke.pekerjaan && ke.pekerjaan.id) return;
    if (!this.itemPekerjaan.length) return;

    const dariPasien = String(
      (this.statePasien && this.statePasien.pekerjaan) || ""
    ).trim();
    if (!dariPasien || dariPasien === "-") return;

    const cocok = this.itemPekerjaan.find(
      o => String(o.nama).toLowerCase() === dariPasien.toLowerCase()
    );
    if (cocok) {
      this.$set(ke, "pekerjaan", cocok);
      return;
    }
    const lain = this.itemPekerjaan.find(o => this.isPekerjaanLainId(o.id));
    if (!lain) return;
    // Identitas pasien memang "LAIN-LAIN" (label master, di form jadi "Lainnya")
    // — cukup pilih opsinya tanpa menyalin teks master ke isian bebas.
    if (dariPasien.toLowerCase().startsWith("lain")) {
      this.$set(ke, "pekerjaan", lain);
      return;
    }
    // Tidak ada di master (mis. data lama) — simpan sebagai Lainnya + teks asli.
    this.$set(ke, "pekerjaan", lain);
    this.$set(ke, "pekerjaan_lain", dariPasien);
  }

  get agama() {
    if (this.catatan["id"] == undefined) {
      this.religion = {};
      this.catatan["kebutuhan_edukasi"].agama = {};
      this.catatan["kebutuhan_edukasi"].agama_lain = "";
      if (this.statePasien.agama == "Islam") {
        this.religion = { nama: "Islam", id: "1" };
      } else if (this.statePasien.agama == "Katholik") {
        this.religion = { nama: "Katholik", id: "2" };
      } else if (this.statePasien.agama == "Protestan") {
        this.religion = { nama: "Kristen", id: "3" };
      } else if (this.statePasien.agama == "Hindu") {
        this.religion = { nama: "Hindu", id: "4" };
      } else if (this.statePasien.agama == "Budha") {
        this.religion = { nama: "Budha", id: "5" };
      } else {
        this.religion = { nama: "Lainnya", id: "0" };
        this.catatan["kebutuhan_edukasi"].agama_lain = this.statePasien.agama;
      }
    } else {
      this.religion = this.catatan["kebutuhan_edukasi"].agama;
    }
    this.catatan["kebutuhan_edukasi"].agama = this.religion;
    return this.religion;
  }

  set agama(val) {
    this.catatan["kebutuhan_edukasi"].agama = val;
  }

  get statePasien() {
    return storePasien.identitasPasien || ({} as typeof storePasien.identitasPasien);
  }
  get catatan() {
    return storeCatatanEdukasi.catatanEdukasi;
  }
  // get hambatanEdukasi() {
  //   return storeCatatanEdukasi.hambatanEdukasi;
  // }
  get listKaryawan() {
    return storePerawat.listKaryawan;
  }

  /**
   * Nama Edukator & Unit Pemberi wajib pada tiap baris pelaksanaan edukasi.
   * `idx` diisi saat menyimpan lewat tombol Simpan milik satu seksi profesi —
   * seksi profesi lain sengaja tidak ikut diperiksa supaya satu PPA tidak
   * terhalang oleh baris PPA lain yang belum lengkap.
   */
  validasiEdukator(idx?) {
    const groups = this.catatan["pelaksanaan_edukasi"] || {};
    const kosong = [];
    const keys = idx === undefined ? Object.keys(groups) : [String(idx)];
    keys.forEach(key => {
      const group = groups[key];
      if (!group || !Array.isArray(group.data)) return;
      group.data.forEach((row, i) => {
        const label = `${this.profesiLabel(group.profesi)} baris ${i + 1}`;
        if (!row.pemberi || !row.pemberi.id) {
          kosong.push(`${label}: Nama Edukator`);
        }
        if (!row.unit || !row.unit.id) {
          kosong.push(`${label}: Unit Pemberi`);
        }
      });
    });
    return kosong;
  }

  normalisasiSebelumSimpan() {
    const list_hambatan = this.catatan["kebutuhan_edukasi"].hambatan_list
      .slice()
      .sort(function(a, b) {
        return a.id - b.id;
      });
    if (this.catatan["kebutuhan_edukasi"].hambatan_edukasi == "0") {
      this.catatan["kebutuhan_edukasi"].hambatan_list = [];
    } else {
      this.catatan["kebutuhan_edukasi"].hambatan_list = list_hambatan;
    }
    if (this.catatan["kebutuhan_edukasi"].nilai_status == "0") {
      this.catatan["kebutuhan_edukasi"].nilai = "";
    }
    if (this.isHambatanLain == false) {
      this.catatan["kebutuhan_edukasi"].hambatan_lain = "";
    }
    const ke = this.catatan["kebutuhan_edukasi"];
    if (ke.tinggal && ke.tinggal.id != null && ke.tinggal.id != "0") {
      ke.tinggal_lain = "";
    }
    if (!this.isPenerimaLain) {
      ke.penerima_lain = "";
    }
    if (!this.isPenerimaKeluarga) {
      ke.penerima_hubungan = "";
    }
    const pelaksanaan = this.catatan["pelaksanaan_edukasi"];
    if (Array.isArray(pelaksanaan)) {
      pelaksanaan.forEach(p => {
        if (Array.isArray(p.data)) {
          p.data.forEach(row => {
            if (!this.hasPenerimaLain(row)) {
              row.penerima_lain = "";
            }
            if (!this.hasPenerimaKeluarga(row)) {
              row.penerima_hubungan = "";
            }
          });
        }
      });
    }
    if (ke.agama && ke.agama.id != null && ke.agama.id != "0") {
      ke.agama_lain = "";
    }
    if (ke.pendidikan && ke.pendidikan.id != null && ke.pendidikan.id != "0") {
      ke.pendidikan_lain = "";
    }
    if (!this.isPekerjaanLain) {
      ke.pekerjaan_lain = "";
    }
    if (!this.isHambatanKomunikasiLain) {
      ke.hambatan_komunikasi_lain = "";
    }
    if (ke.bahasa && ke.bahasa.id != null && ke.bahasa.id != "0") {
      ke.bahasa_lain = "";
    }
    if (!this.isBahasaDaerah) {
      ke.bahasa_daerah_jelaskan = "";
    }
    if (!this.isBahasaLain) {
      ke.bahasa_lain_jelaskan = "";
    }
    // console.log(this.catatan["pelaksanaan_edukasi"][0].data[0]);
  }

  payloadCatatan() {
    const pelaksanaan = this.catatan["pelaksanaan_edukasi"];
    if (!Array.isArray(pelaksanaan)) return this.catatan;
    const bersih = pelaksanaan.map(group => {
      if (!group || !Array.isArray(group.data)) return group;
      return {
        ...group,
        data: group.data.map(row => {
          const salinan = { ...row };
          delete salinan._baru;
          return salinan;
        })
      };
    });
    return { ...this.catatan, pelaksanaan_edukasi: bersih };
  }

  kirimCatatan(pesanSukses: string) {
    this.saving = true;
    const payload = this.payloadCatatan();
    const dt =
      this.catatan["id"] == undefined
        ? DataCatatanEdukasi.saveDataCatatanEdukasi(
            this.register,
            this.rm,
            payload
          )
        : DataCatatanEdukasi.editDataCatatanEdukasi(
            this.catatan["id"],
            this.register,
            this.rm,
            payload
          );

    return dt
      .then(resp => {
        if (resp["status"] == 1) {
          storeCatatanEdukasi.actCatatanEdukasi(this.register);
          appModule.NoticeDelay(pesanSukses);
        }
      })
      .finally(() => {
        this.saving = false;
        this.savingProfesi = null;
      });
  }

  simpan() {
    if (this.saving) return;
    const edukatorKosong = this.validasiEdukator();
    if (edukatorKosong.length > 0) {
      appModule.sendErrorAlert(`Lengkapi dulu — ${edukatorKosong.join("; ")}`);
      return;
    }
    const pesan =
      this.catatan["id"] == undefined
        ? "Berhasil Simpan Catatan Edukasi"
        : "Berhasil Ubah Catatan Edukasi";
    this.normalisasiSebelumSimpan();
    this.kirimCatatan(pesan);
  }

  simpanProfesi(idx) {
    if (this.saving) return Promise.resolve();
    const edukatorKosong = this.validasiEdukator(idx);
    if (edukatorKosong.length > 0) {
      appModule.sendErrorAlert(`Lengkapi dulu — ${edukatorKosong.join("; ")}`);
      return Promise.resolve();
    }
    const group = (this.catatan["pelaksanaan_edukasi"] || [])[idx];
    const label = group ? this.profesiLabel(group.profesi) : "Catatan Edukasi";
    this.savingProfesi = idx;
    this.normalisasiSebelumSimpan();
    return this.kirimCatatan(`Berhasil Simpan ${label}`);
  }
  changeUser(p, i) {
    console.log("prof=", p, "  index=", i);
    // console.log(this.catatan["pelaksanaan_edukasi"].data[i]);
    // const date = new Date().toISOString().substr(0, 10);
    // const time = new Date()
    //   .toLocaleString("en-CA", { hour12: false, timeZone: "Asia/Jakarta" })
    //   .toString()
    //   .substr(12, 8);
    const date = moment().format("YYYY-MM-DD");
    const time = moment().format("HH:mm:ss");
    this.catatan["pelaksanaan_edukasi"][p].data[i].time = date + " " + time;
  }
  changeUserLain(p, i) {
    console.log("prof=", p, "  index=", i);
    // console.log(this.catatan["pelaksanaan_edukasi"].data[i]);
    // const date = new Date().toISOString().substr(0, 10);
    // const time = new Date()
    //   .toLocaleString("en-CA", { hour12: false, timeZone: "Asia/Jakarta" })
    //   .toString()
    //   .substr(12, 8);
    const date = moment().format("YYYY-MM-DD");
    const time = moment().format("HH:mm:ss");
    this.catatan["pelaksanaan_edukasi"][p].data_lain[i].time =
      date + " " + time;
  }

  cetak() {
    const routeData =
      http.getAPI() + "/catatan-edukasi-pasien/" + this.catatan["id"] + "/pdf";
    window.open(routeData, "_blank");
  }
  @Watch("catatan.kebutuhan_edukasi.hambatan_list")
  changedval(v) {
    if (!Array.isArray(v)) {
      this.isHambatanLain = false;
      return;
    }
    // memunculkan inputan hambatan lain
    const hambatan_lain = v.filter(hambatan => {
      return hambatan.id == "11";
    });
    if (hambatan_lain.length > 0) {
      this.isHambatanLain = true;
    } else {
      this.isHambatanLain = false;
    }
  }
  // Penerima kini multi-pilih, jadi hanya kosongkan isian yang kategorinya
  // baru saja dilepas — bukan keduanya setiap kali chip berubah.
  changePenerima(obj) {
    if (!this.hasPenerimaLain(obj)) {
      this.setPenerimaLain(obj, "");
    }
    if (!this.hasPenerimaKeluarga(obj)) {
      this.setPenerimaHubungan(obj, "");
    }
  }

  // Baris edukasi lain-lain lama bisa belum punya properti ini,
  // jadi pakai $set supaya tetap reaktif.
  setPenerimaLain(obj, val) {
    if (!obj) return;
    this.$set(obj, "penerima_lain", val || "");
  }

  // Isi/Materi edukasi sekarang pilihan ganda. Baris lama menyimpannya sebagai
  // satu string, jadi dibungkus jadi array saat ditampilkan supaya catatan lama
  // tetap terbaca tanpa migrasi data.
  namaList(data): string[] {
    if (!data) return [];
    const v = data.nama;
    if (Array.isArray(v)) return v;
    const teks = String(v == null ? "" : v).trim();
    return teks === "" ? [] : [teks];
  }

  setNama(data, val) {
    if (!data) return;
    const list = (Array.isArray(val) ? val : [val])
      .map(v => String(v == null ? "" : v).trim())
      .filter(v => v !== "");
    // Baris lama bisa belum reaktif pada properti ini setelah normalisasi.
    this.$set(data, "nama", list);
  }

  // ---- Paraf / TTD pasien-penerima edukasi (gores layar) ------------------
  // Penerima edukasi (pasien/keluarga) tidak punya akun aplikasi, sehingga
  // tidak bisa memakai TTD digital berbasis password/PIN seperti nakes.
  // Parafnya digores di layar dan disimpan sebagai gambar pada baris terkait.
  ttdDialog = false;
  ttdInitial = "";
  ttdNama = "";
  private ttdTarget: Record<string, unknown> | null = null;
  private ttdProfesiIdx: number | null = null;

  get bisaTtd(): boolean {
    return this.bisaSimpan;
  }

  sudahTersimpan(data): boolean {
    return !!data && !data._baru;
  }

  ttdWaktuLabel(at) {
    return at ? moment(at).format("DD-MM-YYYY HH:mm") : "";
  }

  bukaTtdPenerima(idx, baris) {
    if (!this.bisaTtd || !baris) return;
    this.ttdProfesiIdx = idx;
    this.ttdTarget = baris;
    this.ttdInitial = baris.ttd_penerima || "";
    this.ttdNama = baris.nama_penerima || "";
    this.ttdDialog = true;
  }

  simpanTtdPenerima(dataUrl: string) {
    const baris = this.ttdTarget;
    if (!baris || !dataUrl) return;
    // Baris lama belum punya properti ini — pakai $set agar reaktif.
    this.$set(baris, "ttd_penerima", dataUrl);
    this.$set(baris, "ttd_penerima_at", moment().format("YYYY-MM-DD HH:mm:ss"));
    const idx = this.ttdProfesiIdx;
    this.ttdTarget = null;
    this.ttdProfesiIdx = null;
    this.ttdDialog = false;
    if (idx !== null) this.simpanProfesi(idx);
  }

  hapusTtdPenerima(idx, baris) {
    if (!this.bisaTtd || !baris) return;
    this.$set(baris, "ttd_penerima", "");
    this.$set(baris, "ttd_penerima_at", "");
    this.simpanProfesi(idx);
  }

  setPenerimaHubungan(obj, val) {
    if (!obj) return;
    this.$set(obj, "penerima_hubungan", val || "");
  }

  /** Edukator default = user sesi aktif (pakai entri master bila ada). */
  get pemberiSesi() {
    const u = userModule.user;
    if (!u || !u.id) return "";
    return (
      this.listKaryawan.find(k => k && String(k.id) === String(u.id)) || {
        id: u.id,
        nama: u.nama
      }
    );
  }

  /** Unit pemberi default = unit sesi aktif. */
  get unitSesi() {
    const u = userModule.user;
    if (!u || !u.unit_id) return "";
    return { id: u.unit_id, nama: u.unit };
  }

  tambah(val) {
    if (this.readOnly) return;
    // alert(val);
    this.catatan["pelaksanaan_edukasi"][val].data.push({
      id: "",
      time: moment().format("YYYY-MM-DD HH:mm:ss"),
      lama: "",
      nama: [],
      penerima: [],
      penerima_lain: "",
      penerima_hubungan: "",
      metode: [],
      evaluasi: "",
      pemberi: this.pemberiSesi,
      nama_penerima: "",
      ttd_penerima: "",
      ttd_penerima_at: "",
      unit: this.unitSesi,
      _baru: true
    });
  }

  hapus(p, i) {
    if (this.readOnly) return;
    // alert(val);
    // this.catatan["pelaksanaan_edukasi"][p].data_lain.splice(i, 1);
    this.catatan["pelaksanaan_edukasi"][p].data.splice(i, 1);
  }

  itemEdukasiFor(profesi: string): string[] {
    return materiEdukasiFor(profesi);
  }

  profesiTersembunyi = [
    "Administrasi",
    "Manajemen Nyeri",
    "Penggunaan Alat Medis"
  ];

  tampilkanProfesi(list): boolean {
    if (!list) return false;
    if (!this.profesiTersembunyi.includes(list.profesi)) return true;
    return Array.isArray(list.data) && list.data.length > 0;
  }

  get maxDate(): Date {
    return new Date();
  }

  // Kolom disimpan sebagai string "YYYY-MM-DD HH:mm:ss", picker bekerja dgn Date.
  waktuRow(val): Date | null {
    return val ? moment(val).toDate() : null;
  }

  setWaktu(data, val) {
    if (this.readOnly) return;
    this.$set(
      data,
      "time",
      val ? moment(val).format("YYYY-MM-DD HH:mm:ss") : ""
    );
  }

  timeRender(val) {
    const jam = val ? String(val).substr(11, 8) : "";
    return jam ? jam.substring(0, 5) : "";
  }
  setUnit(row, unit) {
    if (!row) return;
    this.$set(row, "unit", unit ? { id: unit.id, nama: unit.nama } : "");
  }

  // unit = {};

  // list = [];
}
